import { render, staticRenderFns } from "./tsvideo.vue?vue&type=template&id=821bebf8&scoped=true&"
import script from "./tsvideo.vue?vue&type=script&lang=js&"
export * from "./tsvideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "821bebf8",
  null
  
)

export default component.exports